module.exports = __webpack_public_path__ + "static/Bazaarvoice-534b5d3b839593a46d3106cbf9705120.png";